// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"507":"9dfc7de1","515":"4b685e33","838":"c80ad8c5","922":"a2bf6585"}[chunkId] + ".css";
};